import { FileItem, FileUploader } from 'ng2-file-upload';

/** Custom metadata attached to FileItem.some (the raw File object) at upload time. */
export interface DmsFileMeta {
    id: string;
    title: string;
    error_message?: string;
    savedName?: string;
    duplicate_action?: 'duplicated' | 'overwritten' | 'canceled';
}

/**
 * Subclass of FileItem that widens `some` from protected to public
 */
export class DmsFileItem extends FileItem {
    declare public some: File & DmsFileMeta;
}

/**
 * Subclass of FileUploader whose queue is typed as DmsFileItem[].
 * Cast from the FileUploader returned by Util.fileUpload().
 */
export class DmsFileUploader extends FileUploader {
    declare queue: DmsFileItem[];
}
